
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { LineItemFormValues } from './hooks/useLineItemFormSchema';

interface CustomMarkupOverrideProps {
  form: UseFormReturn<LineItemFormValues>;
  onCustomMarkupChange: (value: number) => void;
  onCustomMarginChange: (value: number) => void;
}

const CustomMarkupOverride: React.FC<CustomMarkupOverrideProps> = ({
  form,
  onCustomMarkupChange,
  onCustomMarginChange
}) => {
  return (
    <div className="grid grid-cols-1 gap-4">
      <FormField
        control={form.control}
        name="custom_markup"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Custom Markup (%)</FormLabel>
            <FormControl>
              <Input
                type="number"
                step="0.01"
                value={field.value ?? ''}
                onChange={(e) => {
                  const val = e.target.value;
                  const value = val === '' ? ('' as any) : parseFloat(val);
                  onCustomMarkupChange(value);
                }}
                onBlur={(e) => {
                  const val = parseFloat(e.target.value);
                  if (isNaN(val) || e.target.value === '') {
                    onCustomMarkupChange(0);
                  }
                }}
              />
            </FormControl>
            <FormDescription>
              Percentage added to base cost
            </FormDescription>
          </FormItem>
        )}
      />
    </div>
  );
};

export default CustomMarkupOverride;
